// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7af01e9a","239":"4a911d18","453":"33454aea","455":"5ffbc954"}[chunkId] + ".chunk.js";
};